class PieChart extends React.Component {
  componentDidMount() {
    this.updateChart(this.props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.data.toString() !== this.props.data.toString()) {
      this.updateChart(nextProps);
    }

    return false;
  }

  updateChart(props) {
    let {
      data,
      size,
      hole,
      colors,
      tip,
      transition
    } = props;

    let outerRadius = size / 2;
    let innerRadius = outerRadius - (outerRadius * (1 - hole));

    let arc = d3.arc()
      .outerRadius(outerRadius)
      .innerRadius(innerRadius);

    let pie = d3.pie().sort(null);

    let arcTween = function (endDatum, i) {
      let interpolate = d3.interpolate(this._current || {}, endDatum);

      return (t) => {
        this._current = endDatum;
        return arc(interpolate(t));
      };
    };

    let node = ReactDOM.findDOMNode(this);

    let paths = d3.select(node)
      .select("g")
      .selectAll("path")
      .data(pie(data));

    paths = paths
      .enter()
      .append("path")
      .each(function (d) {
        this._current = d;
      })
      .merge(paths);

    paths
      .attr("fill", function (d, i) {
        return colors[i];
      })
      .attr("data-tooltip", function (d, i) {
        return tip ? tip(d.value, i) : null;
      });

    if (transition) {
      paths
        .interrupt()
        .transition()
        .duration(transition)
        .attrTween("d", arcTween);
    }
    else {
      paths.attr("d", arc);
    }

    paths
      .exit()
      .remove();
  }

  render() {
    let { size, rotate, hole, margin = "0 1em 1em 0"  } = this.props;
    let radius = size / 2;
    let transform = "translate(" + radius + "," + radius + ") rotate(" + rotate + ")";
    let stroke = (size - (size * hole)) / 2;

    return (
      <svg className="mc-chart" width={size} height={size} style={{ margin }}>
        <circle
          cx={radius}
          cy={radius}
          r={radius - (stroke / 2)}
          fill="none"
          stroke="rgba(0,0,0,0.05)"
          strokeWidth={stroke}/>
        <g transform={transform}/>
      </svg>
    );
  }
}

PieChart.defaultProps = {
  colors: [], // required
  data: [], // required
  size: 75,
  rotate: 0,
  transition: 500,
  hole: 0.0,
  tip: function (val, idx) {
    return val;
  }
};

module.exports = PieChart;